import React, { useState, useEffect } from "react"
import { Table, Button, Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"
import { Link, useParams } from "react-router-dom"

const EditMaterialItem = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [categories, setCategories] = useState([])
  const [brands, setBrands] = useState([])
  const [items, setItems] = useState([])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const response = await api.put("update-material-item/" + id, values)
    if (response.data.success === true) setSubmitted(true)
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    const itemResp = await api.get("material-item/" + id)
    const catResp = await api.get("categories")
    const matResp = await api.get("materials")
    setItems(itemResp.data.data[0])
    setCategories(Array.isArray(catResp.data.data) ? catResp.data.data : catResp.data.data?.data || [])
    setBrands(Array.isArray(matResp.data.data) ? matResp.data.data : matResp.data.data?.data || [])
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Edit Material Item</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/materials" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal mt-4"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="category"
                    value={items.category}
                    label="Material Category"
                    required
                  >
                    <option value="">Select Category</option>
                    {categories.map((category, i) => (
                      <option key={i} value={category.id}>
                        {category.materialCategory}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="brand"
                    value={items.brand}
                    label="Brand"
                    required
                  >
                    <option value="">Select Brand</option>
                    {brands.map((brand, i) => (
                      <option key={i} value={brand.id}>
                        {brand.materialName}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="itemName"
                    label="Material Item Name"
                    value={items.itemName}
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="itemCode"
                    label="Material Item Code"
                    value={items.itemCode}
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="description"
                    label="Description"
                    value={items.description}
                    type="textarea"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="hsnCode"
                    label="HSN Code"
                    value={items.hsnCode}
                    type="text"
                    required
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="price"
                    label="Price"
                    value={items.price}
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    value={items.gst}
                    name="gst"
                    label="GST Tax %"
                    required
                  >
                    <option value="">Select GST</option>
                    <option value="1">No GST</option>
                    <option value="2">5%</option>
                    <option value="3">12%</option>
                    <option value="4">18%</option>
                    <option value="5">28%</option>
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    value={items.unitType}
                    name="unitType"
                    label="Unit Type"
                    required
                  >
                    <option value="">Select Unit Type</option>
                    <option value="1">Admin 1</option>
                    <option value="2">Admin 2</option>
                    <option value="3">Admin 3</option>
                    <option value="4">Admin 4</option>
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvRadioGroup
                    inline
                    value={items.decimalQty}
                    name="decimalQty"
                    label="Allow Decimal Quantity"
                    required
                    errorMessage="Pick one!"
                  >
                    <AvRadio label="Yes" value="1" />
                    <AvRadio label="No" value="0" />
                  </AvRadioGroup>
                </div>
              </Col>
            </Row>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Material Item is Updated!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Updating...</span>
                    </>
                  ) : (
                    <span>Update Item </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditMaterialItem
